import { getBaseUrl } from '../common/getBaseUrl';
import {
  deleteData,
  getBlobData,
  getData,
  postData,
  postForm,
} from '../common/getData';
import { createHeaders } from '../common/lib/createHeaders';
import { formatSwedishDateTime } from '../common/lib/formatSwedishDateTime';
import { ApiError } from '../types/ApiError';
import { ApiResponse } from '../types/ApiResponse';
import { BlobApiResponse } from '../types/BlobApiResponse';
import { Forteckning } from './types/Forteckning';
import { CreateForteckningDto } from './types/dtos/CreateForteckningDto';
import { DeleteForteckningarDto } from './types/dtos/DeleteForteckningarDto';
import { ForteckningMetadataDto } from './types/dtos/ForteckningDto';
import { UploadResponseDto } from './types/dtos/UploadResponseDto';

const port = '8574';
const path = '/api/forteckningar/v2';

export const uploadShpFile = async (
  file: File
): Promise<ApiResponse<UploadResponseDto> | ApiResponse<ApiError>> => {
  const formData = new FormData();
  formData.append('file', file);
  return postForm<UploadResponseDto>(
    `${getBaseUrl(path, port)}/forteckningar/upload`,
    formData,
    createHeaders('multipart/form-data')
  );
};

export const fetchForteckningstransaktioner = async (): Promise<
  ApiResponse<string[]>
> => getData<string[]>(`${getBaseUrl(path, port)}/auth`, createHeaders());

export const uploadFile = (
  file: File
): Promise<ApiResponse<UploadResponseDto>> => {
  const body = new FormData();
  body.append('attachment', file);

  const fullPath = `${getBaseUrl(path, port)}/forteckningar/upload`;

  return postForm(fullPath, body, createHeaders());
};

export const listForteckningar = () =>
  getData<ForteckningMetadataDto[], Forteckning[]>(
    `${getBaseUrl(path, port)}/forteckningar`,
    createHeaders(),
    (forteckningar) =>
      forteckningar.map(
        (forteckning): Forteckning => ({
          ...forteckning,
          registreradTidpunkt: formatSwedishDateTime(
            forteckning.registreradTidpunkt
          ),
        })
      )
  );

export const getAsBlob = (id: string): Promise<BlobApiResponse> =>
  getBlobData(
    `${getBaseUrl(path, port)}/forteckningar/${id}/xlsx`,
    createHeaders()
  );

export const createForteckning = (
  typ: string,
  forteckning: CreateForteckningDto,
  kundmarke?: string
): Promise<ApiResponse<ForteckningMetadataDto>> =>
  postData(
    `${getBaseUrl(path, port)}/forteckningar?typ=${typ}`,
    forteckning,
    createHeaders(undefined, kundmarke)
  );

export const deleteForteckning = (id: string) =>
  deleteData(
    `${getBaseUrl(path, port)}/forteckningar/${id}`,
    undefined,
    createHeaders()
  );

export const deleteForteckningar = (ids: string[]) =>
  deleteData(
    `${getBaseUrl(path, port)}/forteckningar`,
    { uuids: ids } as DeleteForteckningarDto,
    createHeaders()
  );

export const retryCreateForteckning = (id: string) =>
  postData(
    `${getBaseUrl(path, port)}/forteckningar/${id}/retry`,
    undefined,
    createHeaders()
  );
